<lib-dialog
  [title]="'language-selection-dialog.text.title' | translate"
  (closeButtonClick)="closeDialog()"
>
  <div body>
    <label>{{ 'language-selection-dialog.text.hint' | translate }}</label>

    <lib-spacer [height]="10"></lib-spacer>

    <mat-radio-group class="radio-group" [formControl]="languageControl">
      <mat-radio-button *ngFor="let language of LANGUAGES" [value]="language">
        <img
          class="flag-icon"
          alt="{{ language.countryCode }}"
          src="/assets/svg-country-flags/{{
            language.countryCode?.toLowerCase()
          }}.svg"
        />
        {{ 'pipes.language.' + language.languageCode | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <ng-container action>
    <lib-spacer></lib-spacer>
    <button mat-stroked-button color="primary" (click)="closeDialog()">
      {{ 'language-selection-dialog.buttons.close' | translate }}
    </button>
    <lib-spacer></lib-spacer>
  </ng-container>
</lib-dialog>
